import React from 'react';
import { TestDriveCalendar } from '@lucid/test-drive-scheduler';
import '@lucid/test-drive-scheduler/dist/test-drive-scheduler.css';
import { useSchedulerHostProps } from '../../../hooks/useSchedulerHostProps';

const TestDriveCalendarPage: React.FC = () => <TestDriveCalendar {...useSchedulerHostProps()} />;

export default TestDriveCalendarPage;
